import { ReadonlySignal, signal } from "@preact/signals";
import { store } from "~/core/store";
import { isPdfMime } from "~/utils";
import { getPdfThumbnails } from "../api/utils";
import { ShareAction, SharedFile } from "./interfaces";

let fileIdx = 0;

const STUB_FN = () => {};

const makeShare = () => {
    const loading = signal(false);
    const error = signal<string | null>(null);
    const sharedFiles = signal<SharedFile[]>([]);
    const clicked = signal(false);
    const action = signal<ShareAction | null>(null);
    let cleanupHeader = STUB_FN;

    const processSharedFiles = async (
        files: SharedMobile.InputSharedFile[],
    ) => {
        loading.value = true;

        try {
            sharedFiles.value = await Promise.all(
                files.map(async (file) => {
                    const array = Uint8Array.from(
                        atob(file.base64.split(",")[1]),
                        (c) => c.charCodeAt(0),
                    );

                    return {
                        ...file,
                        id: String(++fileIdx),
                        blob: new Blob([array], {
                            type: file.type,
                        }),
                        thumbnails: isPdfMime(file.type)
                            ? await getPdfThumbnails(array.buffer)
                            : [file.base64],
                    };
                }),
            );
        } catch (err: unknown) {
            const message =
                err instanceof Error ? err.message : "Unknown error";

            error.value = message;
        }

        loading.value = false;
    };

    const click = (selectedAction: ShareAction) => {
        clicked.value = true;
        action.value = selectedAction;

        if (selectedAction === ShareAction.UpdateExpense) {
            cleanupHeader = store.mobile.hideHeader("share");
        }
    };

    const restart = () => {
        action.value = null;
        clicked.value = false;
        cleanupHeader();
        cleanupHeader = STUB_FN;
    };

    const cleanup = () => {
        sharedFiles.value = [];
        action.value = null;
        clicked.value = false;
        loading.value = false;
        error.value = null;
        delete window.SharedMobile?.sharedFiles;
        cleanupHeader();
        cleanupHeader = STUB_FN;
    };

    const check = () => {
        window.SharedMobile?.shareFiles?.();
    };

    window.SharedMobile ??= {};

    window.SharedMobile.shareFiles = () => {
        if (window.SharedMobile?.sharedFiles) {
            processSharedFiles(window.SharedMobile.sharedFiles);
        }
    };

    return {
        loading: loading as ReadonlySignal<boolean>,
        error: error as ReadonlySignal<string | null>,
        sharedFiles: sharedFiles as ReadonlySignal<SharedFile[]>,
        clicked: clicked as ReadonlySignal<boolean>,
        action: action as ReadonlySignal<ShareAction | null>,
        click,
        cleanup,
        check,
        restart,
    };
};

export default makeShare;
